import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faInfoCircle, faCog, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { IoChevronDownCircleSharp, IoChevronBackCircleSharp } from "react-icons/io5";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; 
import { Link, useNavigate } from "react-router-dom";
import { HiChevronLeft } from "react-icons/hi2";

function Sidebar({ isOpen, toggleSidebar }) {
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const navigate = useNavigate();

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const HandleLogout = () => {
    localStorage.removeItem("admin_token");  
    navigate("/"); 
  };

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      navigate("/"); 
    }
  }, [navigate]);

  return (
    <div className={`sidebar ${isOpen ? "expanded" : "collapsed"}`}>
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        <FontAwesomeIcon
          icon={isOpen ? FaChevronLeft : FaChevronRight}
          className="sidebar-toggle-icon"
        />
      </div>

      <ul className="menu">
        <li className="menu-item bg-info">
          <Link to="/software/dashboard" className="menu-link">
            <i className="nav-icon fas fa-tachometer-alt menu-icon" />
            {isOpen && <span className="menu-text text-dark">Dashboard</span>}
          </Link>
        </li>

        <li
          className={`menu-item ${openMenuIndex === 2 ? "open" : ""}`}
          onClick={() => toggleMenu(2)}
        >
          <div className="menu-link">
            <i className="nav-icon fas fa-truck menu-icon" />
            {isOpen && <span className="menu-text">Car</span>}
            <FontAwesomeIcon
              icon={openMenuIndex === 2 ? IoChevronBackCircleSharp : IoChevronDownCircleSharp}
              className="menu-toggle-icon"
            />
          </div>
          <ul className={`submenu ${openMenuIndex === 2 ? "open" : ""}`}>
            <Link className="menu-link" to="/software/AddCar">
              <li className="submenu-item">Add Car</li>
            </Link>
            <Link className="menu-link" to="/software/CarList">
              <li className="submenu-item">Car List</li>
            </Link>
          </ul>
        </li>
        <li
          className={`menu-item ${openMenuIndex === 6 ? "open" : ""}`}
          onClick={() => toggleMenu(6)}
        >
          <div className="menu-link">
            <i className="nav-icon fas fa-truck menu-icon" />
            {isOpen && <span className="menu-text">OfferCar</span>}
            <FontAwesomeIcon
              icon={openMenuIndex === 6 ? IoChevronBackCircleSharp : IoChevronDownCircleSharp}
              className="menu-toggle-icon"
            />
          </div>
          <ul className={`submenu ${openMenuIndex === 6 ? "open" : ""}`}>
            <Link className="menu-link" to="/software/offerCar">
              <li className="submenu-item">Add Car</li>
            </Link>
            <Link className="menu-link" to="/software/offercarList">
              <li className="submenu-item">Car List</li>
            </Link>
          </ul>
        </li>

        <li
          className={`menu-item ${openMenuIndex === 5 ? "open" : ""}`}
          onClick={() => toggleMenu(5)}
        >
          <div className="menu-link">
            <i className="nav-icon fas fa-road menu-icon" />
            {isOpen && <span className="menu-text">Contact List</span>}
            <FontAwesomeIcon
              icon={openMenuIndex === 5 ? IoChevronBackCircleSharp : IoChevronDownCircleSharp}
              className="menu-toggle-icon"
            />
          </div>
          <ul className={`submenu ${openMenuIndex === 5 ? "open" : ""}`}>
            <Link className="menu-link" to="/software/contactlist">
              <li className="submenu-item">Contact List </li>
            </Link>
          </ul>
        </li>

        <li
          className={`menu-item ${openMenuIndex === 3 ? "open" : ""}`}
          onClick={() => toggleMenu(3)}
        >
          <div className="menu-link">
            <i className="nav-icon fas fa-user menu-icon" />
            {isOpen && <span className="menu-text">Booking</span>}
            <FontAwesomeIcon
              icon={openMenuIndex === 3 ? IoChevronBackCircleSharp : IoChevronDownCircleSharp}
              className="menu-toggle-icon"
            />
          </div>
          <ul className={`submenu ${openMenuIndex === 3 ? "open" : ""}`}>
            <Link className="menu-link" to="/software/booking">
              <li className="submenu-item">Booking Management</li>
            </Link>
          </ul>
        </li>
        <li
          className={`menu-item ${openMenuIndex === 4 ? "open" : ""}`}
          onClick={() => toggleMenu(4)}>
          <div className="menu-link">
            <i className="nav-icon fas fa-user menu-icon" />
            {isOpen && <span className="menu-text">Users</span>}
            <FontAwesomeIcon
              icon={openMenuIndex === 4 ? IoChevronBackCircleSharp : IoChevronDownCircleSharp}
              className="menu-toggle-icon"
            />
          </div>
          <ul className={`submenu ${openMenuIndex === 4 ? "open" : ""}`}>
            <Link className="menu-link" to="/software/user">
              <li className="submenu-item">User List</li>
            </Link>
          </ul>
        </li>

        <li className="menu-item">
          <Link to="/software/changepassword" className="menu-link">
            <i className="nav-icon fa fa-key menu-icon" />
            {isOpen && <span className="menu-text">Change Password</span>}
          </Link>
        </li>

        <li className="menu-item">
          <a className="menu-link" onClick={HandleLogout}>
            <i className="nav-icon fa-solid fa-right-from-bracket menu-icon"></i>
            {isOpen && <span className="menu-text">Logout</span>}
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
